import {DateTime} from "luxon";
import React from "react";
import { Card } from "../Card/index.tsx";

const renderActivityMeta = (activity) => {
    switch(activity.type.toLowerCase()) {
        case 'reservation':
            return (
                <p className={'text-xs'}>
                    <ul>
                        <li>Party Size: {activity?.typeMeta?.partySize}</li>
                        <li>Origin: {activity?.typeMeta?.originChannel}</li>
                        <li>Reservation Time: {DateTime.fromISO(activity?.typeMeta?.reservationTime).toLocal().toFormat('MMMM d, yyyy hh:mm a')}</li>
                    </ul>

                </p>
            );
        case 'ticketed order':
            return (
                <p className={'text-xs'}>
                    <ul>
                        {activity.typeMeta.tickets.map((ticket) => {
                            function decodeHtml(html) {
                                var txt = document.createElement("textarea");
                                txt.innerHTML = html;
                                const val = txt.value;
                                txt.remove()
                                return val;
                            }
                            return <li>Ticket: {decodeHtml(ticket)}</li>
                        })}
                    </ul>

                </p>
            )
        case 'tour':
            return (
                <p className={'text-xs'}>
                    <ul>
                        <li>Event: {activity.typeMeta?.eventName || 'N/A'}</li>
                        <li>Event Date: {activity.typeMeta?.eventDateISO ? DateTime.fromISO(activity.typeMeta.eventDateISO).toLocal().toFormat('MMMM d, yyyy') : 'N/A'}</li>
                    </ul>
                </p>
            )
        case 'admin activity':
            return (
                <p className={'text-xs'}>
                    <ul>
                        <li>Reason: {activity.typeMeta?.reason || 'N/A'}</li>
                        <li>Notes: {activity.typeMeta?.notes || 'No Notes'}</li>
                    </ul>
                </p>
            )
    }
}

const ActivityList = ({activity, future, title, setModalContent, setReceiptData, openModal, admin}) => {
    const activityData = activity?.data ?? [];

    if(admin === undefined) {
        admin = false;
    }

    return (
        <Card className='min-h-[150px] p-4'>
            {activityData.length === 0 ? (
                <div className="flex items-center pt-6 h-[50px]">
                    <div className="text-3xl">|</div>
                    <div className="pl-8">No previous {title} items were found.</div>
                </div>
            ) : (
                activityData.map((activity) => (
                    (activity.future == future && (title !== 'upcoming' || activity.status !== 'PROSPECT') && (
                        (!admin && activity.type != 'Admin Activity')
                        ||
                        (admin && activity.type == 'Admin Activity')
                    )
                    ) &&
                    <div key={activity.identifer} className='bg-white ring-1 ring-aoh-border dark:bg-zinc-800 dark:ring-0 p-2 rounded-lg dark:rounded'>
                        <div className='flex justify-between items-start mb-2'>
                            <div>

                                <h3 className={'text-md font-bold'}>{activity.type} </h3>


                                <h3 className='text-sm font-semibold text-aoh-ink dark:text-zinc-100'>
                                    {activity.typeDescriptor} on{" "}
                                    {DateTime.fromISO(activity?.activityDate).toLocal().toFormat('MMMM d, yyyy hh:mm a')}
                                </h3>

                                {renderActivityMeta(activity)}

                            </div>
                            <div className="text-right">
                                <span
                                className="uppercase font-semibold inline-block bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-sm dark:bg-blue-900 dark:text-blue-300">
                                    {activity.status}
                                </span>
                                <p className="font-bold text-aoh-ink dark:text-zinc-100">
                                {activity.price ? parseFloat(activity.price).toLocaleString('en-US', {
                                        style: 'currency',
                                        currency: 'USD',
                                    }) : ''}
                                </p>
                            </div>
                        </div>
                        <div className="flex justify-end mt-3">
                            {activity.attachedOrder?.order?.checks?.length > 0 && (
                                <button
                                    onClick={() => {
                                        setModalContent('receipt');
                                        setReceiptData(activity.attachedOrder)
                                        openModal();
                                    }}
                                    className="px-4 py-2 bg-aoh-accent hover:bg-aoh-accent/90 text-white font-bold rounded-lg transition duration-300 dark:bg-[#CAAB6A] dark:hover:bg-[#b99b5f] dark:text-black dark:rounded-md"
                                >
                                    View Receipt
                                </button>
                            )}
                        </div>
                    </div>
                ))
            )}
        </Card>
    );

}


export default ActivityList